export type XPixelQueue = {
  (...args: any[]): void;
  exe?: (...args: any[]) => void;
  queue?: IArguments[];
  version?: string;
};

declare global {
  interface Window {
    twq?: XPixelQueue;
  }
}

const X_PIXEL_SCRIPT_ID = "x-universal-website-tag";
const X_PIXEL_SCRIPT_SRC = "https://static.ads-twitter.com/uwt.js";

const createXPixelQueue = (): XPixelQueue => {
  const twq = function () {
    if (twq.exe) {
      twq.exe.apply(twq, arguments as any);
      return;
    }

    twq.queue = twq.queue || [];
    twq.queue.push(arguments);
  } as XPixelQueue;

  twq.version = "1.1";
  twq.queue = [];

  return twq;
};

const hasXPixelScript = (): boolean =>
  !!document.getElementById(X_PIXEL_SCRIPT_ID) ||
  !!document.querySelector(`script[src="${X_PIXEL_SCRIPT_SRC}"]`);

const insertXPixelScript = () => {
  if (hasXPixelScript()) {
    return;
  }

  const script = document.createElement("script");
  script.id = X_PIXEL_SCRIPT_ID;
  script.async = true;
  script.src = X_PIXEL_SCRIPT_SRC;

  const firstScript = document.getElementsByTagName("script")[0];

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
};

export const configureXPixel = (pixelId: string) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  if (!pixelId) {
    return;
  }

  window.twq = window.twq || createXPixelQueue();
  insertXPixelScript();
  window.twq("config", pixelId);
};
